import Quill from "quill";
const Delta = Quill.import("delta");

class Editor {
  constructor(elem) {
    if (!document.querySelector(elem)) {
      return;
    }
    this.quill = new Quill(elem, {
      theme: "snow",
      syntax: true,
      placeholder: "Add your content...",
      modules: { toolbar: true },
    });
  }
  setContents(data) {
    //const formattedResponse = data.replace(/&nbsp;/g, " ");
    this.quill.clipboard.dangerouslyPasteHTML(data);
  }
  getContents() {
    const data = this.quill.getSemanticHTML();
    const formattedResponse = data.replace(/&nbsp;/g, " ");
    return formattedResponse;
  }
}

export { Editor };
